import type { EmblaCarouselType } from 'embla-carousel';
import type { HorizontalScrollState } from '#lib/utils/horizontalScrollHint/index.js';

/**
 * Keeps carousel controls and edge fades in sync with Embla. Embla's own
 * scrollability methods are more reliable than comparing transformed element
 * positions, particularly after a responsive reinitialisation.
 */
export const emblaScrollHint = (
	node: HTMLElement,
	api: EmblaCarouselType,
	onChange: (state: HorizontalScrollState) => void
) => {
	const update = () => {
		const canScrollPrevious = api.canScrollPrev();
		const canScrollNext = api.canScrollNext();
		const canScroll = canScrollPrevious || canScrollNext;

		node.dataset.scrollHint = canScroll ? 'true' : 'false';
		node.dataset.scrollStart = canScrollPrevious ? 'false' : 'true';
		node.dataset.scrollEnd = canScrollNext ? 'false' : 'true';

		onChange({
			canScroll,
			atStart: !canScrollPrevious,
			atEnd: !canScrollNext,
		});
	};

	api.on('select', update);
	api.on('settle', update);
	api.on('reInit', update);
	update();

	return () => {
		api.off('select', update);
		api.off('settle', update);
		api.off('reInit', update);
	};
};
